import { useEffect } from 'react';

import faviconAborted from '@/assets/favicon-aborted.svg';
import faviconFailed from '@/assets/favicon-failed.svg';
import faviconProgress from '@/assets/favicon-in-progress.svg';
import faviconSuccess from '@/assets/favicon-success.svg';
import BuildStatus from '@/models/BuildStatus';

import { PipelineStatus } from '../../../models/Pipeline';

const getFaviconUrl = (status: BuildStatus | PipelineStatus) => {
  switch (status) {
    case BuildStatus.Aborted:
    case PipelineStatus.ABORTED:
      return faviconAborted;
    case BuildStatus.Error:
    case PipelineStatus.FAILED:
      return faviconFailed;
    case BuildStatus.Running:
    case PipelineStatus.RUNNING:
    case PipelineStatus.ON_HOLD:
    case PipelineStatus.TRIGGERED:
    case PipelineStatus.INITIALIZING:
      return faviconProgress;
    case BuildStatus.AbortedWithSuccess:
    case BuildStatus.Success:
    case PipelineStatus.SUCCEEDED:
    case PipelineStatus.SUCCEEDED_WITH_ABORT:
      return faviconSuccess;
    default:
      return faviconProgress;
  }
};

const useUpdateFavicon = (status?: BuildStatus | PipelineStatus): void => {
  useEffect(() => {
    const updateFavicon = () => {
      if (status === undefined) {
        return;
      }

      const url = getFaviconUrl(status);
      const link = document.querySelector<HTMLLinkElement>("link[rel='icon'][type='image/svg+xml']");

      if (link) {
        link.href = url;
      }
    };

    updateFavicon();
  }, [status]);
};

export default useUpdateFavicon;
